@if ({usersMap: usersMap$ | async, teamsMap: teamsMap$ | async}; as state) {
  <div class="avatar-container">
    @if (!combinedItems().length) {
      <oph-avatar
        [background]="'#A3A099'"
        [imgUrl]="'assets/img/icons/user-white.svg'"
        [type]="'user'"
        [imgStyle]="{width: '1rem', height: '1rem'}"
        [size]="avatarSize()"
      />
    } @else {
      @for (item of displayData().visibleItems; track item.id) {
        @if (item.type === 'user') {
          <oph-avatar
            [tooltipText]="state.usersMap[item.id]?.firstName + ' ' + state.usersMap[item.id]?.lastName"
            [tooltipPosition]="tooltipPosition()"
            [isTooltipDisabled]="toolTipDisabled()"
            [user]="state.usersMap[item.id]"
            [type]="'user'"
            [size]="avatarSize()"
          />
        } @else {
          <oph-avatar
            [tooltipText]="state.teamsMap?.[item.id]?.name"
            [tooltipPosition]="tooltipPosition()"
            [isTooltipDisabled]="toolTipDisabled()"
            [name]="state.teamsMap?.[item.id]?.name"
            [type]="'other'"
            [size]="avatarSize()"
          />
        }
      }

      @if (displayData().showRemaining) {
        <div
          class="remaining-count-circle"
          [style.width.px]="avatarSize() + 4"
          [style.height.px]="avatarSize() + 4"
          [style.line-height.px]="avatarSize() + 4"
          [matTooltip]="getRemainingItemsTooltip(state.usersMap, state.teamsMap)"
          [matTooltipPosition]="tooltipPosition()"
          [matTooltipDisabled]="toolTipDisabled()"
          [matTooltipClass]="tooltipSeparator() === 'line' ? 'multiline-tooltip' : ''"
        >
          +{{ displayData().remainingCount }}
        </div>
      }
    }
  </div>
}
